"use client";

import * as Accordion from "@radix-ui/react-accordion";
import { Minus, Plus } from "lucide-react";
import type { FaqItem } from "@/content/landing";
import { site } from "@/config/site";

type FaqProps = {
  headline: string;
  perex: string;
  items: FaqItem[];
};

export function Faq({ headline, perex, items }: FaqProps) {
  return (
    <section id="faq" aria-labelledby="faq-title" className="paper-scope section-pad">
      <div className="container-page grid grid-cols-1 gap-12 lg:grid-cols-[minmax(0,380px)_1fr] lg:gap-16">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <h2 id="faq-title" className="h2-display">
            {headline}
          </h2>
          <p className="mt-5 max-w-[380px] text-[15px] leading-relaxed text-paper-muted">
            {perex}
          </p>
          <a href={`mailto:${site.email}`} className="ghost-pill ghost-pill-paper mt-6">
            Nemáte odpověď? Napište nám →
          </a>
        </div>

        <Accordion.Root
          type="single"
          collapsible
          defaultValue="faq-0"
          className="border-t border-paper-line"
        >
          {items.map((item, index) => (
            <Accordion.Item
              key={item.question}
              value={`faq-${index}`}
              className="group border-b border-paper-line data-[state=open]:border-l-2 data-[state=open]:border-l-signal data-[state=open]:pl-5"
            >
              <Accordion.Header className="flex">
                <Accordion.Trigger className="flex w-full items-start justify-between gap-6 py-5 text-left">
                  <span className="flex items-start gap-4">
                    <span className="mono-index mt-1 text-blue">
                      § {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="h3-ui text-[18px] text-paper-text">{item.question}</span>
                  </span>
                  <span className="mt-1 text-paper-muted">
                    <Plus size={18} className="block group-data-[state=open]:hidden" />
                    <Minus size={18} className="hidden text-signal group-data-[state=open]:block" />
                  </span>
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content className="accordion-content">
                <p className="pb-6 pl-[52px] pr-8 text-[15px] leading-relaxed text-paper-muted">
                  {item.answer}
                </p>
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </div>
    </section>
  );
}
